import type { SalesMoveActionResult } from "@sales-ops-amplify/shared";

type Props = {
  result: SalesMoveActionResult | null;
  onUndo?: () => void;
  onDismiss?: () => void;
};

export function SalesMoveExecutionFeedback({ result, onUndo, onDismiss }: Props) {
  if (!result) return null;
  return (
    <div className="mb-3 rounded-md border border-border bg-muted/20 px-3 py-2.5 text-sm">
      <p className="font-medium text-foreground">{result.message}</p>
      {result.sideEffects.length > 0 ? (
        <ul className="mt-1.5 space-y-0.5 text-xs text-muted-foreground">
          {result.sideEffects.map((s, i) => (
            <li key={`${s.system}-${i}`}>
              {s.description}
              {s.status === "SIMULATED" ? " (simulated)" : s.status === "FAILED" ? " (failed)" : ""}
            </li>
          ))}
        </ul>
      ) : null}
      <div className="mt-2 flex gap-3">
        {result.undo?.available && onUndo ? (
          <button
            type="button"
            onClick={onUndo}
            className="text-xs font-medium text-brand hover:underline"
          >
            Undo
          </button>
        ) : null}
        {onDismiss ? (
          <button
            type="button"
            onClick={onDismiss}
            className="text-xs text-muted-foreground hover:underline"
          >
            Dismiss
          </button>
        ) : null}
      </div>
    </div>
  );
}
